import {AbstractMulti as SuperAbstractMulti} from "../../../clone/dialog/AbstractMulti";
import {IRuleset} from "../../../index";
import {global} from "../../../appContext";
import PromiseRequest from "../../../req/PromiseRequest";
import {ObjectTypeId} from "../../../constants";

export {Step} from '../../../clone/dialog/AbstractMulti'

export abstract class AbstractMulti extends SuperAbstractMulti<IRuleset> {
    protected req_fetch: PromiseRequest = global.getPromiseRequest('searchruleset')
    protected readonly objectTypeId: ObjectTypeId = ObjectTypeId.Ruleset
}